window.addEventListener('DOMContentLoaded', function () {
    // 管理メニュー
    const supplierMenuToggle = document.querySelector('.js-supplier-menu-toggle');
    const supplierMenuList = document.querySelector('.js-supplier-menu-list');

    if (!supplierMenuToggle || !supplierMenuList) {
        return;
    }

    const supplierTriangle = supplierMenuToggle.querySelector('.triangle');

    function syncSupplierTriangleToListState() {
        if (!supplierTriangle) {
            return;
        }
        supplierTriangle.textContent = supplierMenuList.classList.contains('is-open') ? '▲' : '▼';
    }

    syncSupplierTriangleToListState();

    supplierMenuToggle.addEventListener('click', function () {
        supplierMenuList.classList.toggle('is-open');
        syncSupplierTriangleToListState();
    });

    // マスタ管理
    const masterManagerToggle = document.querySelector('.js-master-manager-toggle');
    const masterManagerList = document.querySelector('.js-master-manager-list');

    if (!masterManagerToggle || !masterManagerList) {
        return;
    }

    const masterManagerTriangle = masterManagerToggle.querySelector('.triangle');
    
    function syncMasterManagerTriangleToListState() {
        if (!masterManagerTriangle) {
            return;
        }
        masterManagerTriangle.textContent = masterManagerList.classList.contains('is-open') ? '▲' : '▼';
    }

    syncMasterManagerTriangleToListState();

    masterManagerToggle.addEventListener('click', function () {
        masterManagerList.classList.toggle('is-open');
        syncMasterManagerTriangleToListState();
    });
});